module.exports = __webpack_public_path__ + "static/media/box-cancel-icon.41ec5698.svg";